define('frontend-common-components/objectStorageConfig/js/views/layouts/addAzureStorageLayout',[
    './baseAddStorageLayout',
    'hbs!../../../templates/items/addAzureStorage',
        '../../views/items/bucketSpecifyConfigurationView',
    '../../helpers/azureHelper',
    '../../controllers/bucketListingController',
    '../../helpers/bucketSpecifyTemplateHelper',
    '../../constants/events',
    'i18n!../../../nls/objectStorageConfig',
    'underscore',
    'lodash',
    'jquery'
],
function (
    BaseAddStorageLayout,
    addStorageTmpl,
    BucketSpecifyConfigurationView,
    azureHelper,
    BucketListingController,
    bucketSpecifyTemplateHelper,
    Events,
    messageBundle,
    _,
    lodash,
    $
) {
    'use strict';
    var AddAzureStorageView = BaseAddStorageLayout.extend({
        template: addStorageTmpl,
        className: 'add-cloud-storage-view add-azure-storage-view',
        ui: {
            confirmAddStorage: '#confirm-add-storage',
            azureMessageArea: '#azure-message',
            accountField: '#azure-storage-account',
            keyField: '#azure-storage-key'
        },

        regions: {
            bucketConfigurationBody: '.bucket-configuration-body'
        },

        events: {
            'click @ui.confirmAddStorage': 'saveStorageConfig',
            'keyup @ui.accountField': 'handleAccountFieldKeyUp',
            'paste @ui.accountField': 'handleMousePaste',
            'keyup @ui.keyField': 'handleKeyFieldKeyUp',
            'paste @ui.keyField': 'handleMousePaste'
        },

        initialize: function (options) {

            this.initializeBucketListingController(options);
            this.initializeBucketSpecifyConfigurationView(options);

            this.listenTo(this.model, 'save:success', this.handleSaveSuccess, this);
            this.listenTo(this.model, 'save:error', this.handleSaveError, this);

            this.handleInputFieldsChangeProxy = lodash.debounce(_.bind(this.handleInputFieldsChange, this), 1000);
        },

        initializeBucketListingController: function (options) {
            if (options.bucketListingController) {
                this.bucketListingController = options.bucketListingController;
            } else {
                this.bucketListingController = new BucketListingController({
                    baseURL: options.baseURL
                });
            }
        },

        initializeBucketSpecifyConfigurationView: function (options) {
            if (options.bucketSpecifyConfigurationView) {
                this.bucketSpecifyConfigurationView = options.bucketSpecifyConfigurationView;
            } else{
                this.bucketSpecifyConfigurationView = new BucketSpecifyConfigurationView({
                    templateHelpers: bucketSpecifyTemplateHelper(messageBundle.storage.addPanel.azure)
                });
            }

        },

        handleAccountFieldKeyUp: function (event) {
            var immediate = false;
            if (event.keyCode === 13) {
                immediate = true;
            }
            this.callToInputFieldChange(immediate);
        },

        handleKeyFieldKeyUp: function (event) {
            var immediate = false;
            if (event.keyCode === 13) {
                immediate = true;
            }
            this.callToInputFieldChange(immediate);
        },

        callToInputFieldChange: function (immediate) {
            //hide the container options when a change is detected
            this.clearAzureAccountErrors();

            if (_.isUndefined(immediate)) {
                immediate = false;
            }
            if (!_.isEmpty(this.ui.accountField.val()) && !_.isEmpty(this.ui.keyField.val())) {
                if (immediate) {
                    //If they press enter... do an immediate fetch and cancel any delayed fetches
                    this.handleInputFieldsChange();
                    this.handleInputFieldsChangeProxy.cancel();
                } else {
                    this.handleInputFieldsChangeProxy();
                }
            } else {
                // make sure we cancel any pending container
                // fetches when the user has typed an invalid value in the interim
                this.handleInputFieldsChangeProxy.cancel();
            }
        },

        validateAzureAccountDetails: function () {
            if (!_.isEmpty(this.ui.accountField.val()) && !_.isEmpty(this.ui.keyField.val())) {
                return true;
            }
            // mark with an "empty" message
            this.emptyBucketSpecifyConfigurationContent();
            this.showError(this.ui.azureMessageArea, messageBundle.storage.addPanel.notValidCredentials);
            //this.hideContainerOptionsAndDisableAddCloudStorageButton();
            return false;
        },

        validateFields: function () {
            this.clearErrors();
            var isValidAzureAccount = this.validateAzureAccountDetails();
            var isValidBlobPrefix = this.bucketSpecifyConfigurationView.validateAWSBucketPrefix();
            return isValidAzureAccount && isValidBlobPrefix;
        },

        saveStorageConfig: function (event) {
            this.ui.confirmAddStorage.prop('disabled', true);
            if (event) {
                event.preventDefault();
            }

            if (this.validateFields()) {
                this.triggerMethod(Events.configSaving);
                this.unregisterDocumentHandEventHandlers();

                this.model.set('accountName', this.ui.accountField.val().trim());
                this.model.set('accessKey', this.ui.keyField.val().trim());

                this.bucketSpecifyConfigurationView.setConfigurationValues(this.model);

                this.model.save();
            } else {
                this.ui.confirmAddStorage.prop('disabled', false);
            }

        },

        clearErrors: function () {
            this.clearAzureAccountErrors();
            this.bucketSpecifyConfigurationView.clearDirectoryPrefixErrors();
        },

        clearAzureAccountErrors: function () {
            this.ui.azureMessageArea.text('');
        },

        handleSaveSuccess: function () {
            this.ui.confirmAddStorage.prop('disabled', false);
            this.triggerMethod(Events.configSaveSuccess);
            this.registerDocumentHandEventHandlers();
            this.trigger(Events.azureConfigAdded, this.model);
            this.closeAddStorageView();
        },

        handleSaveError: function (model, response) {
            this.ui.confirmAddStorage.prop('disabled', false);
            this.triggerMethod(Events.configSaveFailure, response);
            this.registerDocumentHandEventHandlers();
        },

        closeAddStorageView: function () {
            this.handleInputFieldsChangeProxy.cancel();
            BaseAddStorageLayout.prototype.closeAddStorageView.call(this);
        },

        onShow: function () {
            BaseAddStorageLayout.prototype.onShow.call(this);
            this.disableAddCloudStorageButton();
            this.ui.accountField.focus();
            this.bucketConfigurationBody.show(this.bucketSpecifyConfigurationView);
        },

        handleInputFieldsChange: function () {
            this.loadContainerList();
        },

        loadContainerList: function () {
            this.triggerMethod(Events.containerListLoading);
            this.unregisterDocumentHandEventHandlers();
            var account = this.ui.accountField.val().trim(),
                key = this.ui.keyField.val().trim();
            this.isAccountFieldFocused  = this.ui.accountField.is(':focus');
            this.ui.accountField.blur();
            this.ui.keyField.blur();

            return this.bucketListingController.getAzureContainerList(account, key)
                .done(_.bind(function (containerList) {
                    this.handleContainerSpecifyConfigurationsDisplay(containerList);
                }, this))
                .fail(_.bind(function () {
                    this.handleAccountFailureWithMessage(messageBundle.storage.addPanel.notValidCredentials);
                }, this))
                .always(_.bind(function () {
                    this.triggerMethod(Events.containerListComplete)
                    this.registerDocumentHandEventHandlers();
                }, this));
        },

        handleContainerSpecifyConfigurationsDisplay: function (containerList) {
            this.unHideBucketConfigurationOptions(containerList);
            this.enableAddCloudStorageButton();
        },

        handleAccountFailureWithMessage: function (errorMessage) {
            this.hideBucketConfigurationOptions();
            this.disableAddCloudStorageButton();
            this.showError(this.ui.azureMessageArea, errorMessage);
            if (this.isAccountFieldFocused === true) {
                this.ui.accountField.focus();
            } else {
                this.ui.keyField.focus();
            }
        },

        hideBucketConfigurationOptions: function () {
            this.bucketSpecifyConfigurationView.hideBucketOptionsAndDisableAddCloudStorageButton();
        },

        unHideBucketConfigurationOptions: function (containerList) {
            this.bucketSpecifyConfigurationView.show(containerList);
        },

        emptyBucketSpecifyConfigurationContent: function () {
            this.bucketConfigurationBody.empty();
        },

        disableAddCloudStorageButton: function () {
            this.ui.confirmAddStorage.attr('disabled', 'disabled');
        },

        enableAddCloudStorageButton: function () {
            this.ui.confirmAddStorage.removeAttr('disabled');
        },

        handleMousePaste: function () {
            // make sure we cancel any pending container
            // fetches when the user has pasted something in role ARN field
            this.handleInputFieldsChangeProxy.cancel();
            setTimeout(_.bind(function () {
                this.callToInputFieldChange();
            }, this), 100);
        },

        onDestroy: function () {
            console.log('closing "add Azure storage" view. Canceling pending rest calls');
            this.handleInputFieldsChangeProxy.cancel();
        }
        
    });

    return AddAzureStorageView;
});
